import { SegmentedBarCard, useContainerQuery } from '@backrs_ui/common-ui';
import type { AcademicExperienceRowData, SegmentedBarRowData } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { getMajorAttributeDisplayLabel } from '../majors.utils';

const STRINGS = appStrings.modules.majors.academicExperience;

type AcademicExperienceRowCardProps = Readonly<{
  rows: readonly AcademicExperienceRowData[];
  majorName: string;
}>;

export const AcademicExperienceRowCard = ({ rows, majorName }: AcademicExperienceRowCardProps) => {
  const [containerRef, isCompact] = useContainerQuery(600);

  const segmentedRows: SegmentedBarRowData[] = rows.map((row) => ({
    title: row.title,
    infoVariant: row.tooltipText ? { type: 'tooltip' as const, text: row.tooltipText } : undefined,
    options: row.options.map((option) =>
      getMajorAttributeDisplayLabel(row.attributeKey, option, isCompact),
    ),
    selectedValue: getMajorAttributeDisplayLabel(
      row.attributeKey,
      String(row.selectedValue),
      isCompact,
    ),
  }));

  return (
    <SegmentedBarCard
      containerRef={containerRef}
      title={STRINGS.keyAttributes(majorName)}
      rows={segmentedRows}
    />
  );
};
